<template>
  <div class="my">
    <div class="top"></div>
    <div class="my_title">我的</div>
    <div class="logo">
      <img class="logo_img" src="@/assets/adule_img/btnList/logo.png" alt="" />
      <div class="logo_des">
        <div class="logo_des1">座享乐舒</div>
        <div class="logo_des2">座享陪伴 舒适安心</div>
      </div>
      <img class="seat" src="@/assets/adule_img/btnList/seat2.png" alt="" />
    </div>
    <div class="card_block">
      <div class="item_card">
        <img
          class="card_img"
          src="@/assets/adule_img/btnList/card1.png"
          alt=""
        />
        <div class="card_des">商务合作</div>
        <img class="arrow" src="@/assets/adule_img/btnList/arrow.png" alt="" />
      </div>
      <div class="item_card">
        <img
          class="card_img2"
          src="@/assets/adule_img/btnList/card2.png"
          alt=""
        />
        <div class="card_des">售后客服</div>
        <img class="arrow" src="@/assets/adule_img/btnList/arrow.png" alt="" />
      </div>
      <div class="item_card" @click="gotoOeder">
        <img
          class="card_img3"
          src="@/assets/adule_img/btnList/card3.png"
          alt=""
        />
        <div class="card_des">用户服务</div>
        <img class="arrow" src="@/assets/adule_img/btnList/arrow.png" alt="" />
      </div>
      <div class="item_card">
        <img
          class="card_img3"
          src="@/assets/adule_img/btnList/card3.png"
          alt=""
        />
        <div class="card_des">隐私政策协议</div>
        <img class="arrow" src="@/assets/adule_img/btnList/arrow.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WorkspaceJsonMy",

  data() {
    return {};
  },

  mounted() {},

  methods: {
    // 点击用户服务去全部订单页面，可进行退款
    gotoOeder() {
      this.$router.push({ path: "/orderList" });
    },
  },
};
</script>

<style lang="scss" scoped>
.my {
  background: linear-gradient(to bottom, #c1f7f5, #fff);
  background-size: cover;
  width: 100%;
  height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 30px 0;
  box-sizing: border-box;
  .top {
    width: 130vw;
    height: 34vh;
    background: #78dedd;
    border-radius: 50%;
    position: absolute;
    top: -6vh;
    z-index: 0;
  }
  .my_title {
    font-family: FZLanTingHeiS-DB-GB;
    font-weight: 400;
    font-size: 17px;
    color: #000000;
    position: absolute;
    top: 1vh;
    z-index: 1;
  }
  .logo {
    position: absolute;
    z-index: 2;
    display: flex;
    align-items: center;
    top: 10vh;
    left: 6vw;
    .logo_img {
      width: 115px;
      height: 45px;
    }
    .logo_des {
      position: absolute;
      left: 18vw;
      width: 100%;
      .logo_des1 {
        font-family: FZLanTingHei-B_GB18030;
        font-weight: bold;
        font-size: 18px;
        color: #ffffff;
      }
      .logo_des2 {
        font-family: FZLanTingHeiS-DB-GB;
        font-weight: 400;
        font-size: 11px;
        color: #ffffff;
        margin-top: 3px;
      }
    }
  }
  .seat {
    width: 150px;
    height: 228px;
    position: absolute;
    left: 47vw;
  }
  .card_block {
    width: 88%;
    background: #fff;
    border-radius: 10px;
    padding: 4vh 4vw 3vh 7vw;
    box-sizing: border-box;
    position: absolute;
    top: 20vh;
    z-index: 3;
    .item_card {
      display: flex;
      align-items: center;
      height: 8vh;
      .card_img {
        width: 25px;
        height: 18px;
        margin-right: 3vw;
        margin-left: -1vw;
      }
      .card_img2 {
        width: 15px;
        height: 18px;
        margin-right: 5vw;
      }
      .card_img3 {
        width: 17px;
        height: 18px;
        margin-right: 5vw;
      }
      .card_des {
        font-family: FZLanTingHeiS-DB-GB;
        font-weight: 600;
        font-size: 16px;
        color: #000000;
        margin-top: -1px;
      }
      .arrow {
        height: 15px;
        margin-left: auto;
      }
    }
  }
}
</style>
